export const build_message = (node, channel) => ({
    as_user: true,
    blocks: [{
        type: "rich_text",
        elements: [{
            type: "rich_text_section",
            elements: build_message_blocks(node)
        }],
    }],
    channel,
    type: 'message',
})

export function build_message_blocks(node, message_blocks = [], style = {}, include_node = false, stop_node = false, is_root = true) {
    let result, stop = false
    Array.from(node.childNodes).some(child_node => {
        switch (child_node.nodeName) {
            case '#text':
                const item = {
                    text: child_node.data,
                    type: 'text',
                }
                if (include_node) {
                    item.node = child_node
                }
                if (Object.keys(style).length) {
                    item.style = style
                }
                if (item.text) {
                    message_blocks.push(item)
                }
                break
            case 'B':
            case 'STRONG':
                result = build_message_blocks(child_node, message_blocks, { ...style, bold: true }, include_node, stop_node, false)
                message_blocks = result.message_blocks
                stop = result.stop
                break
            case 'CODE':
                result = build_message_blocks(child_node, message_blocks, { ...style, code: true }, include_node, stop_node, false)
                message_blocks = result.message_blocks
                stop = result.stop
                break
            case 'EM':
            case 'I':
                result = build_message_blocks(child_node, message_blocks, { ...style, italic: true }, include_node, stop_node, false)
                message_blocks = result.message_blocks
                stop = result.stop
                break
            case 'SPAN':
                if (child_node.classList.contains('slack-mention')) {
                    const user_id = child_node.getAttribute('data-id')
                    message_blocks.push({
                        type: "user",
                        user_id,
                    })
                } else if (child_node.classList.contains('c-emoji')) {
                    const name = child_node.getAttribute('data-id')
                        , skin_tone = child_node.getAttribute('data-skin-tone')
                        , data = {
                            type: "emoji",
                            name,
                        }
                    if (skin_tone) {
                        data.skin_tone = skin_tone
                    }
                    message_blocks.push(data)
                } else {
                    result = build_message_blocks(child_node, message_blocks, { ...style }, include_node, stop_node, false)
                    message_blocks = result.message_blocks
                    stop = result.stop
                    break
                }
                break
            case 'S':
            case 'STRIKE':
                result = build_message_blocks(child_node, message_blocks, { ...style, strike: true }, include_node, stop_node, false)
                message_blocks = result.message_blocks
                stop = result.stop
                break
            case 'IMG':
                child_node.remove()
                break
            default:
                const text = {
                    text: child_node.textContent,
                    type: 'text',
                }
                if (include_node) {
                    text.node = child_node
                }
                if (Object.keys(style).length) {
                    text.style = style
                }
                if (text.text) {
                    message_blocks.push(text)
                }
                break
        }
        if (stop_node && child_node.isSameNode(stop_node)) {
            return stop = true
        }
    })
    return is_root && message_blocks || { message_blocks, stop }
}

export function get_caret_pixel_pos($node, offsetx, offsety) {
    offsetx = offsetx || 0
    offsety = offsety || 0

    var nodeLeft = 0,
        nodeTop = 0
    if ($node) {
        nodeLeft = $node.offsetLeft
        nodeTop = $node.offsetTop
    }

    var pos = { left: 0, top: 0 }
    const r = $node.getBoundingClientRect()

    if (document.selection) {
        var range = document.selection.createRange()
        pos.left = range.offsetLeft + offsetx - nodeLeft + 'px'
        pos.top = range.offsetTop + offsety - nodeTop + 'px'
    } else if (window.getSelection) {
        var sel = window.getSelection()
        var range = sel.getRangeAt(0).cloneRange()
        try {
            range.setStart(range.startContainer, range.startOffset - 1)
        } catch (e) { }
        var rect = range.getBoundingClientRect()
        if (range.endOffset == 0 || range.toString() === '') {
            // first char of line
            if (range.startContainer == $node) {
                // empty div
                if (range.endOffset == 0) {
                    pos.top = '0px'
                    pos.left = '0px'
                } else {
                    // firefox need this
                    var range2 = range.cloneRange()
                    range2.setStart(range2.startContainer, 0)
                    var rect2 = range2.getBoundingClientRect()
                    pos.left = rect2.left + offsetx - nodeLeft + 'px'
                    pos.top = rect2.top + rect2.height + offsety - nodeTop + 'px'
                }
            } else {
                pos.top = range.startContainer.offsetTop + 'px'
                pos.left = range.startContainer.offsetLeft + 'px'
            }
        } else {
            pos.left = rect.left + rect.width + offsetx - nodeLeft - r.x + 'px'
            pos.top = rect.top + offsety - nodeTop - r.y + 'px'
        }
    }
    return pos
}

export function get_html_from_element(block) {
    let text = block.text
    const { bold, code, italic, strike } = block.style || {}
    if (strike) {
        text = `<s>${text}</s>`
    }
    if (italic) {
        text = `<em>${text}</em>`
    }
    if (bold) {
        text = `<strong>${text}</strong>`
    }
    if (code) {
        text = `<code>${text}</code>`
    }
    return text
}

export function get_parent(tag = '', node, parent) {
    let active = false
    tag = tag.toUpperCase()
    node = node.parentElement
    do {
        active = node.tagName === tag || node.nodeName === tag
        if (active) {
            return node
        }
        node = node.parentElement
    } while (!active && node && !node.isSameNode(parent));
    return null
}

export function get_popup_search_term(editor) {
    return get_text_until_caret(editor).split(/[@]+/).pop()
}

export function toggle_code(editor, wrap = 'code') {
    let s = window.getSelection(), r = s.getRangeAt(0)
    let start_node = r.startContainer, start_node_idx, start_offset = r.startOffset, end_node = r.endContainer, end_offset = r.endOffset
    let all_blocks, blocks
    if (r.startContainer.nodeName !== '#text') {
        start_node = get_text_nodes(start_node.childNodes[r.startOffset])[0]
        start_offset = 0
    }
    if (r.endContainer.nodeName !== '#text') {
        const text_nodes = get_text_nodes(end_node.childNodes[end_offset - 1])
        end_node = text_nodes[text_nodes.length - 1]
        end_offset = end_node.data.length
    }
    all_blocks = build_message_blocks(editor, [], {}, true)
    let end_node_idx = all_blocks.findIndex(b => b.node.isSameNode(end_node))
    start_node_idx = all_blocks.findIndex(b => b.node.isSameNode(start_node))
    blocks = [...all_blocks.slice(start_node_idx, end_node_idx + 1)]
    const every = blocks.every(b => (b.style && b.style.code))
    let final_blocks = []
    for (let idx = 0; idx < all_blocks.length; idx++) {
        let block = all_blocks[idx]
        if (idx === start_node_idx) {
            if (start_offset > 0) {
                const start_block = { ...block, style: { ...block.style, code: !every } }
                start_block.text = block.text.slice(start_offset, block.text.length)
                block.text = block.text.slice(0, start_offset)
                final_blocks.push(block)
                block = start_block
            } else {
                block.style = block.style || {}
                block.style.code = !every
            }
            if (start_node_idx !== end_node_idx) {
                final_blocks.push(block)
            }
        }
        if (idx > start_node_idx && idx < end_node_idx) {
            block.style = block.style || {}
            block.style.code = !every
            final_blocks.push(block)
        } else if (idx !== start_node_idx && idx !== end_node_idx) {
            final_blocks.push(block)
        }
        if (idx === end_node_idx) {
            if (end_offset > 0) {
                if (start_node_idx === end_node_idx) {
                    end_offset -= start_offset
                }
                const end_block = { ...block, style: { ...block.style, code: !every } }
                end_block.text = block.text.slice(0, end_offset)
                block.text = block.text.slice(end_offset, block.text.length)
                block.style = { ...block.style, code: false }
                final_blocks.push(end_block, block)
            } else {
                final_blocks.push(block)
            }
        }
    }
    let html = ''
    let code = false
    start_node_idx = null
    end_node_idx = null
    final_blocks.forEach((b, idx) => {
        let block = { ...b }
        if (b.style && b.style.code) {
            if (!code) {
                html += '<code>'
            }
            block = { ...b, style: { ...b.style, code: false } }
            code = true
        } else if (code) {
            code = false
            html += '</code>'
        }
        if (start_node.isSameNode(b.node) && start_node_idx === null) {
            start_node_idx = idx
        }
        if (end_node.isSameNode(b.node) && end_node_idx === null) {
            end_node_idx = idx
        }
        html += get_html_from_element(block)
    })
    if (code) {
        html += '</code>'
    }
    editor.innerHTML = html
    editor.focus()
    s = window.getSelection()
    r = new Range()
    all_blocks = build_message_blocks(editor, [], {}, true)
    r.setStart(all_blocks[start_node_idx].node, 0)
    r.setEnd(all_blocks[end_node_idx].node, end_offset)
    s.removeAllRanges()
    s.addRange(r)
    return blocks
}

export function get_text_until_caret(editor, selection_ = null) {
    const selection = selection_ || window.getSelection(),
        node = selection.anchorNode,
        nodeOffset = selection.anchorOffset,
        text_nodes = get_nodes_text(editor, [], node)
    if (text_nodes.length) {
        let last = text_nodes[text_nodes.length - 1]
        last = last.slice(0, nodeOffset)
        text_nodes[text_nodes.length - 1] = last
        return text_nodes.join('')
    }
    return ''
}

export function has_parent(tag = '', node, parent) {
    let active = false
    tag = tag.toUpperCase()
    node = node.parentElement
    do {
        active = node.tagName === tag || node.nodeName === tag
        node = node.parentElement
    } while (!active && node && !node.isSameNode(parent));
    return active
}

export function insert_emoji(data, editor) {
    set_end_of_contenteditable(editor)
    let sel = window.getSelection()
    const anchorNode = sel.anchorNode,
        anchorOffset = sel.anchorOffset
    const range = new Range()
    sel.removeAllRanges()
    sel.addRange(range)
    range.setStart(anchorNode, anchorOffset)
    const emoji = document.createElement('span'),
        emoji_content = document.createElement('img')
    emoji.classList.add('c-emoji', 'c-emoji__medium', 'c-emoji--inline')
    emoji.setAttribute('contenteditable', false)
    emoji.setAttribute('data-id', data.name)
    if (data.skin_tone !== 'default') {
        emoji.setAttribute('data-skin-tone', data.skin_tone.replace('skin-tone-', ''))
    }
    emoji_content.setAttribute('src', data.emoji[data.skin_tone])
    emoji.append(' ')
    emoji.append(emoji_content)
    emoji.append(' ')
    range.collapse(true)
    range.insertNode(emoji)
    range.setStartAfter(emoji)
}

export function insert_mention(user, editor, search_term_ = '') {
    let sel = window.getSelection()
    const anchorNode = sel.anchorNode,
        search_term = `@${search_term_}`,
        anchorOffset = sel.anchorOffset - search_term.length
    anchorNode.data = sel.anchorNode.data.replace(search_term, '')
    const range = new Range()
    sel.removeAllRanges()
    sel.addRange(range)
    range.setStart(anchorNode, anchorOffset)
    const mention = document.createElement('span'),
        mention_content = document.createElement('span'),
        mention_text = ` @${user.real_name} `
    mention.classList.add('slack-mention')
    mention.setAttribute('contenteditable', false)
    mention.setAttribute('data-id', user.id)
    mention_content.classList.add('slack-mention-content')
    mention_content.innerText = mention_text
    mention_content.setAttribute('data-id', user.id)
    mention.append(' ')
    mention.append(mention_content)
    mention.append(' ')
    range.collapse(true)
    range.insertNode(mention)
    range.setStartAfter(mention)
}

export function set_cursor(pos, editor) {
    // Creates range object
    var setpos = document.createRange();

    // Creates object for selection
    var set = window.getSelection();

    // Set start position of range
    setpos.setStart(get_text_nodes(editor)[0], pos);

    // Collapse range within its boundary points
    // Returns boolean
    setpos.collapse(true);

    // Remove all ranges set
    set.removeAllRanges();

    // Add range with respect to range object.
    set.addRange(setpos);

    // Set cursor on focus
    editor.focus();
}

export function set_end_of_contenteditable(contentEditableElement) {
    var range, selection
    if (document.createRange) //Firefox, Chrome, Opera, Safari, IE 9+
    {
        range = document.createRange(); //Create a range (a range is a like the selection but invisible)
        range.selectNodeContents(contentEditableElement); //Select the entire contents of the element with the range
        range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
        selection = window.getSelection(); //get the selection object (allows you to change selection)
        selection.removeAllRanges(); //remove any selections already made
        selection.addRange(range); //make the range you have just created the visible selection
    } else if (document.selection) //IE 8 and lower
    {
        range = document.body.createTextRange(); //Create a range (a range is a like the selection but invisible)
        range.moveToElementText(contentEditableElement); //Select the entire contents of the element with the range
        range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
        range.select(); //Select the range (make it the visible selection
    }
}

function get_nodes_text(node, text_nodes = [], stop_node = null) {
    return get_text_nodes(node, text_nodes, stop_node, true)
}

export function get_text_nodes(node, text_nodes = [], stop_node = null, as_text = false) {
    Array.from(node.childNodes).some(child_node => {
        switch (child_node.nodeName) {
            case '#text':
                if (child_node.data !== '') {
                    const item = as_text ? child_node.data : child_node
                    text_nodes.push(item)
                }
                break
            default:
                text_nodes = get_text_nodes(child_node, text_nodes, stop_node, as_text)
                break
        }
        if (stop_node && child_node.isSameNode(stop_node)) {
            return true
        }
    })
    return text_nodes
}